<template>
    <div class="container-fluid">
      <slot />
    </div>
  </template>
  
  <script></script>
  
  <style>
  @import "~/assets/styles/onx.css";
  
  /* * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }
    body {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 1rem;
      line-height: 1.6;
      background: #f4f4f4;
    }
    */
  ul {
    list-style: none;
  }
  
  .container-fluid {
    max-width: 1600px;
    margin: 0 auto;
    /* overflow: hidden; */
    /* overflow-x: auto; */
    padding: 0rem 0rem;
    /* background: #fff; */
  }
  </style>
  